export default () => ({
    loading:false,
    payouts:[],
    total:0,
})
